<template>
<div class="user_order no-trans" v-loading="loading">
    <div class="order_titles">我的咨询<span v-if="mobile_view" class="consultation_count">{{ total }} 条记录</span></div>
    <div class="user_order_box">
        <div class="order_types">
            <div class="lefts">
                <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" role="button" tabindex="0" :aria-pressed="types_ac==item.state" @keydown.enter.prevent="handle_type(item)" @click="handle_type(item)">
                    {{ item.title }}
                </div>
            </div>
            <div class="rights">
                <div v-if="mobile_view" class="mobile_search">
                    <el-input placeholder="搜索咨询内容" aria-label="搜索咨询内容" v-model="keyword" clearable @clear="handle_seach" @keyup.enter.native="handle_seach"></el-input>
                    <button type="button" class="search_submit" aria-label="搜索" title="搜索" @click="handle_seach"><i class="el-icon-search" aria-hidden="true"></i></button>
                </div>
                <el-input v-else
                    placeholder="输入关键字搜索"
                    v-model="keyword" @keyup.enter.native="handle_seach">
                    <div slot="suffix" class="" @click="handle_seach">
                        <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                    </div>
                </el-input>
            </div>
        </div>
        <div class="order_0" v-if="lists.length==0">
            <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
            <div class="texts">{{ mobile_view ? '暂无符合条件的咨询' : '暂无待处理订单' }}</div>
        </div>
        <div class="lists" v-else>
            <div class="lists_tabs">
                <div class="tables tab1">标题内容</div>
                <div class="tables tab2">回复状态</div>
                <div class="tables tab3">提出时间</div>
                <div class="tables tab4">回复时间</div>
                <!-- <div class="tables tab5">回复律师 </div> -->
            </div>
            <div class="lists_items">
                <div class="items" v-for="(item,index) in lists" :key="index">
                    <div class="item1" role="link" tabindex="0" @keydown.enter.prevent="handle_detial(item)" @click="handle_detial(item)">
                        {{ item.content }}
                    </div>
                    <div class="item2" :class="{mobile_answered:!!item.answerTime}">
                        {{ item.answerTime?'已回复':'待回复' }}
                        
                    </div>
                    <div class="item3">
                        {{ item.created_at }}
                    </div>
                    <div class="item4" :class="{mobile_unanswered:!item.answerTime}">
                        {{ item.answerTime }}
                    </div>
                    <!-- <div class="item5">
                        {{ item.answer }} 
                    </div> -->
                </div>
            </div>
        </div>
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(Math.max(1,Math.ceil(total/pages.limit)))">尾页</div>
        </div>
    </div>
    
</div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:0,
            type_list:[
                {
                    title:'全部问答',
                    state:0,
                },
                {
                    title:'待回复',
                    state:2,
                },
                {
                    title:'已回复',
                    state:1,
                }
                
            ],
            lists:[],

            total:0,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
            this.pages.page=1
            this.get_list()
        },
        handle_seach(){
            console.log('点击搜索')
            this.pages.page=1
            this.get_list()

        },
        handleSizeChange(e){
            console.log('条数',e)   
            this.pages.page=1
            this.pages.limit=e
            this.get_list()         
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()

        },
        handle_detial(item){
            this.$router.push({
                path:'/user_zx/user_zx_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_list(){
            this.loading = true
            this.$api("caseLeaveList", {
                ...this.pages,
                keyword:this.keyword,
                status:this.types_ac,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的咨询',res)
                if (res.code == 1) {
                    this.lists=res.data.data
                    this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .lists{
            padding-top: 23px;
            .lists_tabs{
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items:center;
                justify-content: space-between;
                padding: 0 24px;
                .tables{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;

                }
                .tab1{
                    width: 370px;
                    flex-shrink: 0;
                }
                .tab2{
                    width: 120px;
                    flex-shrink: 0;
                }
                .tab3{
                    width: 220px;
                    flex-shrink: 0;
                }
                .tab4{
                    width: 220px;
                    flex-shrink: 0;
                }
                .tab5{
                    width: 170px;
                    flex-shrink: 0;
                }
            }
            .lists_items{
                .items{
                    min-height: 80px;
                    border-left: 1px solid #E5E5E5;
                    border-right: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    padding: 10px 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .item1{
                        width: 370px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        cursor: pointer;
                        &:hover{
                            font-weight: bold;
                        }

                    }
                    .item2{
                        width: 120px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                    .item3{
                        width: 220px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                    .item4{
                        width: 220px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        
                        
                    }
                    .item5{
                        width: 170px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                    }
                }
            }
            
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .order_types {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types {
        font-size: 14px;
        padding-bottom: 12px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types_ac {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__inner {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 3px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix img {
        width: 18px;
    }
    .user_order.no-trans .user_order_box .order_0 {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_0 img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_0 .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .lists {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs .tables {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs .tab1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs .tab2 {
        width: 120px;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs .tab3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs .tab4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .lists .lists_tabs .tab5 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .lists .lists_items .items {
        padding: 10px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .lists .lists_items .items .item1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .lists .lists_items .items .item2 {
        width: 120px;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .lists .lists_items .items .item3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .lists .lists_items .items .item4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .lists .lists_items .items .item5 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
@media (max-width: 1024px) {
    .user_order.no-trans {
        .order_titles { display: flex; align-items: center; justify-content: space-between; gap: 12px; box-sizing: border-box; min-height: 60px; height: auto; padding: 16px 16px 12px; margin: 0; font-size: 18px; font-weight: 600; line-height: 26px; color: #303846; }
        .order_titles .consultation_count { flex-shrink: 0; color: #929aa5; font-size: 13px; font-weight: 400; line-height: 22px; }
        .user_order_box {
            box-sizing: border-box; margin-top: 0; padding: 0 16px 16px;
            .order_types {
                display: flex; flex-direction: column; align-items: stretch; gap: 16px;
                .lefts { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 0; width: 100%; border-bottom: 1px solid #e7ecf2; }
                .lefts .types { box-sizing: border-box; width: auto; margin: 0; padding: 10px 4px; min-height: 46px; text-align: center; font-size: 14px; line-height: 24px; border-bottom-width: 2px; color: #748091; }
                .lefts .types_ac { color: #377cfd; background: #f5f8ff; }
                .rights { width: 100%; }
                .rights /deep/ .el-input { width: 100%; height: 44px; }
                .rights /deep/ .el-input__inner { height: 44px; padding: 0 48px 0 12px; font-size: 16px; border-color: #dfe5ee; }
                .rights /deep/ .el-input__suffix { display: flex; align-items: center; justify-content: center; right: 0; width: 44px; height: 44px; }
                .rights /deep/ .el-input__suffix-inner > div { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; cursor: pointer; }
                .rights /deep/ .el-input__suffix img { width: 18px; height: 18px; object-fit: contain; }
                .rights .mobile_search { display: grid; grid-template-columns: minmax(0,1fr) 46px; gap: 8px; align-items: center; }
                .rights .mobile_search /deep/ .el-input { min-width: 0; height: 46px; }
                .rights .mobile_search /deep/ .el-input__inner { height: 46px; padding-left: 12px; padding-right: 38px; background: #f7f9fc; border-color: #e7ecf2; border-radius: 4px; }
                .rights .mobile_search /deep/ .el-input__inner:focus { background: #fff; border-color: #377cfd; }
                .rights .mobile_search /deep/ .el-input__suffix { width: 38px; height: 46px; }
                .rights .mobile_search .search_submit { box-sizing: border-box; display: flex; align-items: center; justify-content: center; width: 46px; height: 46px; padding: 0; border: 0; border-radius: 4px; background: #377cfd; color: #fff; font-size: 20px; cursor: pointer; }
                .rights .mobile_search .search_submit:focus-visible { outline: 2px solid #2468e8; outline-offset: 2px; }
            }
            .order_0 { padding: 36px 0; }
            .order_0 img { width: 120px; height: auto; }
            .order_0 .texts { font-size: 14px; color: #7b8491; }
            .lists {
                padding-top: 16px;
                .lists_tabs { display: none; }
                .lists_items .items {
                    display: grid; grid-template-columns: minmax(0,1fr) auto; align-items: start; gap: 8px 12px;
                    padding: 16px 0; border-bottom: 1px solid #e7ecf2;
                    .item1 { width: 100%; min-width: 0; font-size: 16px; font-weight: 500; line-height: 25px; min-height: 44px; overflow-wrap: anywhere; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
                    .item2 { width: auto; padding: 3px 7px; background: #fff5e6; border-radius: 4px; color: #b77716; font-size: 13px; line-height: 22px; white-space: nowrap; }
                    .item2.mobile_answered { background: #edf7f1; color: #31865c; }
                    .item3, .item4 { grid-column: ~"1 / -1"; width: 100%; min-width: 0; color: #7b8491; font-size: 13px; line-height: 22px; overflow-wrap: anywhere; }
                    .item3::before { content: '提出时间：'; color: #929aa5; }
                    .item4::before { content: '回复时间：'; color: #929aa5; }
                    .item4.mobile_unanswered { display: none; }
                }
            }
            .pages_box { padding-top: 24px; }
        }
        [role="button"]:focus-visible, [role="link"]:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
    }
}
</style>
